import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'

import { VendorUserV1 } from '../../../api/api/models/vendor-user-v1'
import { CommonComponent } from '../../common.component'
import { UserImage } from '../../user/user-image'
import { Attribute } from '../../attribute/attribute'
import { DialogType } from '../../dialog/dialog-type'

@Component({
  selector: 'app-profile-container',
  templateUrl: './profile-container.component.html',
  styleUrls: ['./profile-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileContainerComponent extends CommonComponent {

  create: boolean
  name: Attribute = {label: 'Name', value: 'name'}
  position: Attribute = {label: 'Specialization', value: 'position'}
  email: Attribute = {label: 'Email', value: 'email', isEmail: true}
  image: any

  form = this.fb.group({
    name: ['', Validators.required],
    position: ['', Validators.required],
    image: [''],
    email: ['', [Validators.required, Validators.email]],
  })

  userVal: VendorUserV1
  @Input() title: string
  @Input() isProfile = true
  @Output() saveProfile = new EventEmitter<VendorUserV1>()
  @Output() upload = new EventEmitter<UserImage>()

  constructor(private fb: FormBuilder) {
    super()
  }

  @Input() set user(user: VendorUserV1) {
    if (user) {
      this.userVal = {imgUrl: '', email: '', position: '', ...user}
      this.form.setValue({
        name: this.userVal.name,
        position: this.userVal.position,
        image: this.userVal.imgUrl,
        email: this.userVal.email
      })
    }
  }

  @Input()
  set type(val: DialogType) {
    if (val.valueOf() === DialogType.Create.valueOf()) {
      this.create = true
    }
    if (val.valueOf() === DialogType.Edit.valueOf()) {
      this.create = false
    }
  }

  onSubmit() {
    if (this.form.invalid) {
      return
    }
    const form = this.form.value
    const user = {
      ...this.userVal,
      name: form.name,
      position: form.position,
      email: form.email,
    } as VendorUserV1

    this.saveProfile.emit(user)
  }

  uploadImage(base64Img: string) {
    this.upload.emit({base64Img, user: this.userVal})
    this.image = null
  }

  getButtonText() {
    return 'Create'
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/profile/profile-container/profile-container.component.ts